import * as z from "zod";

export const createSupportAiSubscription = {
  name: "createSupportAiSubscription" as const,
  input: z.object({}).optional(),
  output: z.object({
    success: z.boolean(),
    confirmationUrl: z.string().optional(),
  }),
};
